import { Inject } from '@odinjs/odin';

import { Attachment, DownloadService, Endpoint } from '@philips-emr/hpms-provider-commons';
import { FetchAPI, FieldAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnMount, OnSelect } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SelectEvent } from '@philips-emr/tws-core/lib/component/types';
import { MessageService } from '@philips-emr/tws-core/lib/services';

import { MessageDetailsAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import './message-details-controller.css';

@Controller({ fragment: FragmentNames.MESSAGE_DETAILS })
class MessageDetailsController extends BaseController {
  @Inject(Aliases.FIELD_ATTACHMENTS)
  private fieldAttachments: FieldAPI;

  @OnMount(Aliases.CONTEXTUAL_BAR_MESSAGE)
  onMountContextualBarDetalhesMensagem(): void {
    const { nrSeqCommunication } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqCommunication });
  }

  @OnSelect(Aliases.ATTACHMENTS_LIST)
  onSelectAnexo(event: SelectEvent<Attachment>): void {
    const { value } = event;
    const { nrSeqAttachment, filename: nmAttachment } = value;

    DownloadService.of({
      endpoint: Endpoint.GET.MESSAGE_ATTACHMENT_DOWNLOAD,
      name: nmAttachment,
      parameters: { nrSeqAttachment },
    });
  }

  @OnAfterFetch(Aliases.FETCH_ATTACHMENTS)
  onAfterFetchAttachments(event: FetchEvent): void {
    if (event.data) {
      const data = event.data as FetchAPI;
      if (data.length > 0) {
        this.fieldAttachments.setLabel(MessageService.translate('provider.attachments'));
      }
    }
  }
}

export {
  MessageDetailsController,
};
